<template>
  <!-- カテゴリイメージを動的に表示するのにjambotronクラスは使用不可（CSS側で背景画像を指定するため）なので、以下に置き換え -->
    <!-- <div id="mainBanner" class="mainImg"> -->

      <!-- <div class="inner"> -->
        <!-- <img :src="app_root + '/assets/createplus/img/category/topimage/' + this.categoryid + '.jpg'"
          height="260"
        /> -->
      <div class="container">
        <div v-if="!isBuiltInApp" class="guidelink_area1">
          <a v-on:click="clickLink()"
            class="guidelinktxt2">
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="12" />&nbsp;&raquo;

          </a>
        </div>

        <div class="category_title">
          <div>
            <CreateplusMessage
              fcontId="1"
              v-bind:flinkId="selectedCategoryNumber"
              msgkey="1"
            />
          </div>
        </div>

      </div>



</template>

<script>
import { mapState, mapGetters } from "vuex";
import CreateplusMessage from "./CreateplusMessage";
export default {
  name: "CreatePlusTemplateListTop",
  props: {
    categoryid: String,
  },
  components: {
    CreateplusMessage,
  },
  computed: {
    ...mapState(["lg2"]),
    ...mapState('createplusTemplates', ['createplusCategories', 'createplusCategoriesStatus', 'createplusTemplates', 'createplusTemplatesStatus']),
    ...mapGetters(["isBuiltInApp"]),

    selectedCategoryNumber: function () {
      const category = this.createplusCategories.find(category => category.categoryID === this.categoryid);
      return category.categoryNumber.toString();
    }
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  methods: {
    clickLink: function () {
      this.$gtag.event("tap_button", {
        "custom_parameter1": "create_guide"
      })
      this.$router.push({ 
        path: "/createplus/" + this.lg2 + "/templates/guide",
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale } 
      });
    }
  }
}
</script>

<style scoped>
</style>